import * as THREE from 'three';
import { box, cyl, sphere } from '../core/meshkit.js';

// 3D builders for the banana folk that live in Banana Village (and wander town).
// Keep them wholesome, bright, and peel-shaped.

const BANANA_BODY = 0xF2D23B;
const BANANA_TIP = 0x6E4526;

// A single stylish banana with stick legs.
export function buildBananaGirl(root){
  // curved body made of a scaled cylinder
  const body = cyl(0.22, 0.18, 1.1, BANANA_BODY, 0, 0.6, 0, root, 12);
  body.rotation.z = 0.12;
  // stem and tip
  cyl(0.06, 0.06, 0.18, BANANA_TIP, -0.1, 1.25, 0, root, 6).rotation.z = 0.12;
  cyl(0.05, 0.05, 0.14, BANANA_TIP, 0.16, 0.08, 0, root, 6).rotation.z = 0.12;
  // little peel collar at the bottom
  cyl(0.24, 0.22, 0.12, 0xFFF4DF, 0.04, 0.18, 0, root, 12).rotation.z = 0.12;
  // face
  sphere(0.06, 0x2E2018, -0.08, 0.85, 0.18, root, 8);
  sphere(0.06, 0x2E2018,  0.06, 0.82, 0.20, root, 8);
  box(0.16, 0.04, 0.04, 0x2E2018, -0.01, 0.72, 0.20, root);
  // arms
  cyl(0.03, 0.03, 0.34, BANANA_BODY, -0.28, 0.62, 0.12, root, 6).rotation.set(0, 0, -0.8);
  cyl(0.03, 0.03, 0.34, BANANA_BODY,  0.32, 0.62, 0.12, root, 6).rotation.set(0, 0, 0.8);
  // stick legs
  cyl(0.035, 0.035, 0.42, 0x5A4A2A, -0.08, -0.21, 0, root, 6);
  cyl(0.035, 0.035, 0.42, 0x5A4A2A,  0.12, -0.21, 0, root, 6);
}

// A cheerful bunch of bananas plus one little walking stick-leg pal.
export function buildBananaBunch(root){
  const bunch = new THREE.Group();
  bunch.position.set(0, 0.85, 0);
  bunch.rotation.z = 0.15;
  root.add(bunch);
  // three bananas
  for (let i = -1; i <= 1; i++){
    const g = new THREE.Group();
    g.position.set(i * 0.28, 0, 0);
    g.rotation.z = i * 0.18;
    bunch.add(g);
    cyl(0.18, 0.16, 0.95, BANANA_BODY, 0, 0, 0, g, 10);
    cyl(0.04, 0.04, 0.12, BANANA_TIP, 0, 0.54, 0, g, 6);
    cyl(0.04, 0.04, 0.10, 0x4A3A2A, 0, -0.52, 0, g, 6);
    // tiny face on the front banana
    if (i === 0){
      sphere(0.045, 0x2E2018, -0.08, 0.08, 0.16, g, 8);
      sphere(0.045, 0x2E2018,  0.08, 0.08, 0.16, g, 8);
      box(0.12, 0.03, 0.03, 0x2E2018, 0, -0.04, 0.16, g);
    }
  }
  // stalk
  cyl(0.06, 0.08, 0.25, 0x4A3A2A, 0, 0.55, 0, bunch, 6);
  // one single banana pal with stick legs
  const pal = new THREE.Group(); pal.position.set(0.55, 0, 0.2); root.add(pal);
  cyl(0.14, 0.12, 0.72, BANANA_BODY, 0, 0.36, 0, pal, 10);
  cyl(0.035, 0.035, 0.05, BANANA_TIP, 0, 0.76, 0, pal, 6);
  cyl(0.035, 0.035, 0.38, 0x5A4A2A, -0.06, -0.19, 0, pal, 6);
  cyl(0.035, 0.035, 0.38, 0x5A4A2A,  0.06, -0.19, 0, pal, 6);
  sphere(0.04, 0x2E2018, -0.05, 0.52, 0.12, pal, 8);
  sphere(0.04, 0x2E2018,  0.05, 0.52, 0.12, pal, 8);
}
